import React from "react";

import { Form, Input, Select, Button, Col, Row } from "antd";
import { v4 as uuidv4 } from "uuid";
import { phoneType } from "../../../../../utils/Util";
const { Option } = Select;
function PhoneNumbers({ phoneNumbers, setPhoneNumbers }) {

  const addPhoneNumbers = () => {
    const newPhoneNumber = {
      id: uuidv4(),
      phoneNumber: "",
      type: "",
      additionalDetails: "",
    };
    setPhoneNumbers([...phoneNumbers, newPhoneNumber]);
  };

  const removePhoneNumber = (id) => {
    const updatedPhoneNumbers = phoneNumbers.filter((item) => item.id !== id);
    setPhoneNumbers(updatedPhoneNumbers);
  };

  const handleChange = (value, name, id) => {
    const updatedPhoneNumbers = phoneNumbers.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setPhoneNumbers(updatedPhoneNumbers);
  };

  return (
    <ul>
      {phoneNumbers.map((item, index) => (
        <li key={item.id}>
          <Form.Item label=" ">
            <Row>
              <Col span={14}>
                <Form.Item label=" " name={`phoneNumber${index}`}>
                  <Input
                    placeholder="Phone Number"
                    type="number"
                    onChange={(e) =>
                      handleChange(e.target.value, "phoneNumber", item.id)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={1} />
              <Col span={8}>
                <Form.Item label="" name={`phoneType${index}`}>
                  <Select
                    onChange={(value) => handleChange(value, "type", item.id)}
                  >
                    {phoneType.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.value}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={1}>
                {phoneNumbers.length > 1 ? (
                  <Button
                    className="roundSmallButton"
                    onClick={() => {
                      removePhoneNumber(item.id);
                    }}
                    type="primary"
                    shape="circle"
                    icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                    size={"small"}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
            <Row>
              <Col span={23} style={{ marginTop: 12 }}>
                <Form.Item label=" " name={`additionalDetails${index}`}>
                  <Input
                    placeholder="Additional Details"
                    onChange={(e) =>
                      handleChange(e.target.value, "additionalDetails", item.id)
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form.Item>
        </li>
      ))}
      <Form.Item label=" ">
        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={addPhoneNumbers}
          size={"small"}
          icon={<i className="fa-solid fa-circle-plus"></i>}
        >
          Add Another Phone Number
        </Button>
      </Form.Item>
    </ul>
  );
}

export default PhoneNumbers;
